import styled from 'styled-components';

import { COLORS } from 'theme';

import Tag from '../..';

export const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.skyBlueDark};
    background: ${COLORS.skyBlueLight};
    border-color: ${COLORS.skyBlue};
    border-radius: ${({ theme }) => theme.borderRadius.full};

    &&& .MuiChip-icon path {
      fill: ${COLORS.skyBlue};
    }
  }
`;

/**
 * MUI already truncates `.MuiChip-label`, but its overflow is invisible to a
 * measurement taken on any ancestor — the chip is capped at `max-width: 100%`,
 * so the ancestor's `scrollWidth` never exceeds its `clientWidth`. Owning the
 * truncation here gives `useIsOverflowing` an element it can actually measure.
 */
export const TagLabel = styled.span`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
